import $ from 'jquery';
import 'magnific-popup';
import './Language/magnific-popup'

(function () {
    var lightboxes = $('a[href="#chat-overlay"]');
    console.log("chat overlay initialized");
    if (lightboxes.length === 0) {
        return;
    }

    lightboxes.magnificPopup({
        type:'inline',
        midClick: true

    });
}());
